import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const Container = styled.div<{ viewed: boolean }>`
  @keyframes borderFade {
    0% {
      border-color: ${colors.green};
    }
    75% {
      border-color: ${colors.green};
    }
    100% {
      border-color: ${colors.white};
    }
  }

  position: relative;
  padding: 16px 40px;
  width: 100%;
  background-color: ${colors.white};
  border: 1px solid ${colors.white};
  border-radius: 4px;
  animation-name: borderFade;
  animation-duration: ${({ viewed }) => (viewed ? 0 : 4)}s;
`

export const Title = styled.span`
  display: inline-block;
  color: ${colors.messegesGreen1};
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
`

export const Description = styled.span`
  display: inline-block;
  color: ${colors.mainText};
  font-size: 14px;
  font-weight: 400;
`

export const TestingModeIcon = styled.img`
  position: absolute;
  top: 19px;
  left: 16px;
  width: 16px;
  height: 16px;
`

export const ButtonsContainer = styled.div`
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  @media ${device.mobileMax} {
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9.5px 40px;
  height: 40px;
  font-size: 14px;
  border-radius: 27px;
  color: ${colors.messegesGreen1};
  background-color: ${colors.white};
  border: 1px solid ${colors.messegesGreen1};
`

export const ButtonSimple = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 16px;
  padding: 0;
  font-size: 14px;
  color: ${colors.messegesGreen1};
  background: transparent;
  border-bottom: 1px dashed ${colors.messegesGreen1};
`
